export const HttpHeaderKey = {
  XAppVersion: 'X-APP-VERSION',
  XDeviceType: 'X-DEVICE-TYPE',
  XDeviceId: 'X-DEVICE-ID',
  XCsrfToken: 'X-CSRFToken',
  Authorization: 'Authorization',
  CacheControl: 'Cache-Control',
};
